import { useSnackbar } from "@mui/base/useSnackbar";
import { Alert, ClickAwayListener } from "@mui/material";
import { keyframes } from "@mui/system";
import React from "react";

type AlertProps = {
  info: "success" | "error";
  children: string;
  value: boolean;
  setValue: (value: any) => void;
};

export default function AlertComponent(props: AlertProps) {
  const snackbarInRight = keyframes`
from {
  transform: translateX(100%);
}

to {
  transform: translateX(0);
}
`;

  const handleClose = () => {
    props.setValue(false);
  };
  
  const { getRootProps, onClickAway } = useSnackbar({
    onClose: handleClose,
    open: props.value,
    autoHideDuration: 5000,
  });

  return (
    <React.Fragment>
      {props.value ? (
        <ClickAwayListener onClickAway={onClickAway}>
          <Alert
            {...getRootProps()}
            severity={props.info}
            style={{
              position: "fixed",
              zIndex: "5500",
              display: "flex",
              right: "16px",
              bottom: "16px",
              left: "auto",
              justifyContent: "start",
              maxWidth: "560px",
              minWidth: "300px",
              fontWeight: 600,
              animation: `${snackbarInRight} 200ms`,
              transition: "transform 0.2s ease-out",
              borderRadius: "8px",
            }}
          >
            {props.children}
          </Alert>
        </ClickAwayListener>
      ) : null}
    </React.Fragment>
  );
}
